// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"K0-z","subtitle":"L0-z","wrapper":"M0-z","leftArrow":"N0-z","rightArrow":"O0-z"};